<template>
    <div
        :class="[
            'DateFilterDropdown',
            isModal && 'DateFilterDropdown--modal'
        ]"
    >
        <div
            v-if="!singleDate"
            :class="[
                'DateFilterDropdown__options',
                isModal && 'DateFilterDropdown__options--modal'
            ]"
        >
            <RPRadioContainer
                class="DateFilterDropdown__option"
                :options="options"
                :value="selected"
                @input="select"
            />
            <RPRadioContainer
                :options="calendarOptions"
                :value="open"
                @input="selectOpen"
            />
        </div>
        <div
            v-if="open !== ''"
            :class="[
                'DateFilterDropdown__calendar-container',
                isModal && 'DateFilterDropdown__calendar-container--modal'
            ]"
        >
            <DatePicker
                :value="currentRange"
                :mode="dateSelector.mode"
                :columns="dateSelector.columns"
                :rows="dateSelector.rows"
                is-inline
                @input="selectRange"
            />
        </div>
        <div
            :class="[
                'DateFilterDropdown__buttons-container',
                open && 'DateFilterDropdown__buttons-container--expand',
                isModal && 'DateFilterDropdown__buttons-container--modal'
            ]"
        >
            <RPButton
                :disabled="submitDisabled"
                size="lg"
                label="Submit"
                class="DateFilterDropdown__button"
                @click="submit"
            />
            <RPButton
                size="lg"
                class="DateFilterDropdown__button"
                type="tertiary"
                label="Cancel"
                @click="$emit('close')"
            />
        </div>
    </div>
</template>
<script>
import DatePicker from 'v-calendar/lib/components/date-picker.umd';
import isEqual from 'lodash/isEqual';
import isEmpty from 'lodash/isEmpty';
import moment from 'moment';
import RPButton from 'components/Basic/Buttons/RPButton.vue';
import RPRadioContainer from '@/components/Basic/FormElements/RPRadioContainer.vue';
export default {
    name: 'DateFilterDropdown',
    components: {
        DatePicker,
        RPButton,
        RPRadioContainer
    },
    props: {
        currentDates: {
            type: Object,
            required: true
        },
        options: {
            type: Array,
            required: true,
        },
        calendarOptions: {
            type: Array,
            required: true,
        },
        isModal: {
            type: Boolean,
            default: false
        },
        singleDate: {
            type: Boolean,
            default: false
        }
    },
    data(){
        return {
            selected: {},
            open: ''
        };
    },
    computed: {
        currentRange(){
            if(!isEmpty(this.selected)){
                return (this.open === 'open-single')
                    ? moment(this.selected.date_to, 'YYYY-MM-DD').toDate()
                    : {
                        start: moment(this.selected.date_from, 'YYYY-MM-DD').toDate(),
                        end: moment(this.selected.date_to, 'YYYY-MM-DD').toDate()
                    };
            }
            return moment().toDate();
        },
        dateSelector(){
            if(this.open === 'open-single') {
                return {
                    mode: 'single',
                    columns: 1,
                    rows: 1,
                };
            }
            return {
                mode: 'range',
                columns: this.isModal ? 1 : 2,
                rows: this.isModal ? 2: 1
            };
        },
        submitDisabled(){
            return isEqual(this.currentDates, this.selected);
        }
    },
    mounted(){
        this.selected = this.currentDates;
        if(!isEmpty(this.selected) && this.options.findIndex(opt => isEqual(opt.value, this.selected)) === -1){
            this.open = isEqual(this.selected.date_from, this.selected.date_to)
                ? 'open-single'
                : 'open-double';
        }
        if(this.singleDate){
            this.open='open-single';
        }
    },
    methods: {
        select(val){
            this.selected = val;
            this.open = '';
        },
        selectOpen(val){
            this.open = val;
            this.selected = {};
        },
        selectRange(s){
            this.selected = (this.open === 'open-single')
                ? {
                    date_from: moment(s).format('YYYY-MM-DD'),
                    date_to: moment(s).format('YYYY-MM-DD'),
                }
                : {
                    date_from: moment(s.start).format('YYYY-MM-DD'),
                    date_to: moment(s.end).format('YYYY-MM-DD'),
                };
        },
        submit(){
            this.$emit('select', this.selected);
        }
    },
};
</script>
<style lang="scss">
    .DateFilterDropdown {
        background: $white;
        border: 1px solid $grey-100;
        box-sizing: border-box;
        box-shadow: 0 2px 5px rgba(0, 0, 0, 0.08);
        border-radius: 4px;
        margin-top: 0.25rem;
        padding: 1rem 0 0 1rem ;
        display: grid;
        grid-template-columns: 1fr auto;
        gap: 1rem;

        &--modal {
            display: flex;
            flex-direction: column;
            overflow-y: auto;
            align-items: center;
            padding: 1rem 0
        }

        &__option{
            margin-bottom: 0.75rem;
        }
        &__options {
            grid-column: 1;
            grid-row: 1;

        }

        &__calendar-container {
            margin-right: 1rem;
            grid-column: 2;
            grid-row: 1;
            &--modal {
                margin-right: 0;
            }
        }
        &__buttons-container {
            grid-column: 1;
            grid-row: 2;
            display: flex;

            &--expand {
                grid-column: span 2;
            }
            &--modal {
                flex-direction: column;
                align-items: center;
            }
        }
        &__button {
            width: 11rem;
            margin-bottom: 0.5rem;
            margin-right: 0.5rem;
        }
    }
</style>
